import { PropertyStatus } from "./PropertyStatus";
import { Listing } from "src/types/listing";
import { EnumProductTypes } from "src/types/listing";
import {
  getDistressedListingRateAsWord,
  getDistressRateColor,
} from "src/utils/listings";
import {
  DistressedIcon,
  ExpiredsIcon,
  FsboIcon,
  NeighborhoodSearchIcon,
  PreforeclosureIcon,
  OldExpiredsIcon,
  DataGenieIcon,
} from "../icons";
import { getListingStatusColors } from "src/utils/listings";
import { LISTING_STATUS_COLORS } from "src/constants/listing";
export const ListingPropertyStatus = ({ listing }: { listing: Listing }) => {
  const { status, productType, type, distressedLevel = 0 } = listing;

  let color =
    productType === EnumProductTypes.distressed
      ? getDistressRateColor(
          distressedLevel ? parseInt(distressedLevel) : 0
        )
      : getListingStatusColors(status || "")?.textColor;

  let IconType = NeighborhoodSearchIcon;
  let title = status || "Unknown";
  let description = type || "Unknown";

  switch (listing.productType) {
    case EnumProductTypes.distressed:
      IconType = DistressedIcon;
      const { description: distressedDescription } =
        getDistressedListingRateAsWord(listing);
      description = distressedDescription || description;
      break;
    case EnumProductTypes.expired:
      IconType = ExpiredsIcon;
      break;
    case EnumProductTypes.preforeclosure:
      IconType = PreforeclosureIcon;
      break;
    case EnumProductTypes.fsbo:
      IconType = FsboIcon;
      break;
    case EnumProductTypes.customupload:
      title = "Data Genie";
      IconType = DataGenieIcon;
      break;
    case EnumProductTypes.ns:
      title = "NS";
      IconType = NeighborhoodSearchIcon;
      color = LISTING_STATUS_COLORS.GREEN.text;
      break;
    case EnumProductTypes.oldexpired:
      IconType = OldExpiredsIcon;
      break;
    default:
      return null;
  }
  return (
    <PropertyStatus
      color={color}
      IconType={IconType}
      title={title}
      description={description}
    />
  );
};
